window.StyleHelper = (function() {
	'use strict';
	var dark = '#000'
	var light = '#FFF'
	var mainColor = {lineColor: '#5A1E64', labelColor: light};

    var colorDictionary = [
        ['#EB691D',dark],
        ['#9A89D9',dark],
        ['#B42D19',light],
        ['#5A469B',light],
        ['#AA1E87',light],
        ['#352B6B',light],
        ['#787070',light]
	];

    function getColor(styleId) {
        var colorToReturn = styleId % colorDictionary.length === 0 ? colorDictionary.length -1 : (styleId % colorDictionary.length) -1;
        return { lineColor: colorDictionary[colorToReturn][0], labelColor: colorDictionary[colorToReturn][1] };
    }

    function getMainColor() {
        return mainColor;
    }

	function getColorCount() {
	    return colorDictionary.length;
	}

	function parseColor(hex) {
		return {
			red: parseInt(hex.substr(1, 2), 16),
			green: parseInt(hex.substr(3, 2), 16),
			blue: parseInt(hex.substr(5, 2), 16)
		};
	}

	function getAlphaColor(hex, alpha) {
		var color = parseColor(hex);
		return 'rgba(' + color.red + ',' + color.green + ',' + color.blue + ',' + alpha + ')';
	}

	return {
		getColor: getColor,
		parseColor: parseColor,
		getAlphaColor: getAlphaColor,
		getColorCount: getColorCount,
	    getMainColor: getMainColor
	};
})();
